import React from "react";

const InfoIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_303_833"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="20"
      >
        <rect x="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_303_833)">
        <path
          d="M10.4993 14.1667C10.7355 14.1667 10.9334 14.0868 11.0931 13.9271C11.2528 13.7674 11.3327 13.5694 11.3327 13.3333V9.99999C11.3327 9.76388 11.2528 9.56596 11.0931 9.40624C10.9334 9.24652 10.7355 9.16666 10.4993 9.16666C10.2632 9.16666 10.0653 9.24652 9.9056 9.40624C9.74588 9.56596 9.66602 9.76388 9.66602 9.99999V13.3333C9.66602 13.5694 9.74588 13.7674 9.9056 13.9271C10.0653 14.0868 10.2632 14.1667 10.4993 14.1667ZM10.4993 7.49999C10.7355 7.49999 10.9334 7.42013 11.0931 7.26041C11.2528 7.10068 11.3327 6.90277 11.3327 6.66666C11.3327 6.43055 11.2528 6.23263 11.0931 6.07291C10.9334 5.91318 10.7355 5.83332 10.4993 5.83332C10.2632 5.83332 10.0653 5.91318 9.9056 6.07291C9.74588 6.23263 9.66602 6.43055 9.66602 6.66666C9.66602 6.90277 9.74588 7.10068 9.9056 7.26041C10.0653 7.42013 10.2632 7.49999 10.4993 7.49999ZM10.4993 18.3333C9.34657 18.3333 8.26324 18.1146 7.24935 17.6771C6.23546 17.2396 5.35352 16.6458 4.60352 15.8958C3.85352 15.1458 3.25977 14.2639 2.82227 13.25C2.38477 12.2361 2.16602 11.1528 2.16602 9.99999C2.16602 8.84721 2.38477 7.76388 2.82227 6.74999C3.25977 5.7361 3.85352 4.85416 4.60352 4.10416C5.35352 3.35416 6.23546 2.76041 7.24935 2.32291C8.26324 1.88541 9.34657 1.66666 10.4993 1.66666C11.6521 1.66666 12.7355 1.88541 13.7493 2.32291C14.7632 2.76041 15.6452 3.35416 16.3952 4.10416C17.1452 4.85416 17.7389 5.7361 18.1764 6.74999C18.6139 7.76388 18.8327 8.84721 18.8327 9.99999C18.8327 11.1528 18.6139 12.2361 18.1764 13.25C17.7389 14.2639 17.1452 15.1458 16.3952 15.8958C15.6452 16.6458 14.7632 17.2396 13.7493 17.6771C12.7355 18.1146 11.6521 18.3333 10.4993 18.3333ZM10.4993 16.6667C12.3605 16.6667 13.9368 16.0208 15.2285 14.7292C16.5202 13.4375 17.166 11.8611 17.166 9.99999C17.166 8.13888 16.5202 6.56249 15.2285 5.27082C13.9368 3.97916 12.3605 3.33332 10.4993 3.33332C8.63824 3.33332 7.06185 3.97916 5.77018 5.27082C4.47852 6.56249 3.83268 8.13888 3.83268 9.99999C3.83268 11.8611 4.47852 13.4375 5.77018 14.7292C7.06185 16.0208 8.63824 16.6667 10.4993 16.6667Z"
          fill="#2B2B2B"
        />
      </g>
    </svg>
  );
};

export default InfoIcon;
